import VConsole from 'vconsole';

let v: any = null
export default () => {
  if (v) return
  v = new VConsole();

  // 下次自动启动
  localStorage.setItem('_v', '1')
}
